"use strict";

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');
var assign = require('object-assign');
var EventEmitter = require('events').EventEmitter;

var CHANGE_EVENT = 'change';

var _uploadedImageUrl = null;
var _uploadedAvatar = null;

var _uploadProgress = {};

var FileUploadStore = assign({}, EventEmitter.prototype, {
  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function (error) {
    this.emit(CHANGE_EVENT, error || null);
  },

  getUploadedImageUrl: function () {
    return _uploadedImageUrl;
  },

  getUploadedAvatar: function () {
    return _uploadedAvatar;
  },

  removeUploadedImageUrl: function () {
    _uploadedImageUrl = null;
  },

  getUploadProgress: function (key) {
    return _uploadProgress.hasOwnProperty(key) ? _uploadProgress[key] : null;
  }
});


Dispatcher.register(function (action) {
  switch (action.actionType) {
    case ActionType.FILE_UPLOAD_IMAGE_UPLOAD_SUCCESS:
      _uploadedImageUrl = action.imageUrl;
      FileUploadStore.emitChange();
      break;

    case ActionType.AVATAR_ULPOAD_SUCCESS:
      _uploadedAvatar = action.avatar;
      FileUploadStore.emitChange();
      break;

    case ActionType.FILE_UPLOAD_IMAGE_UPLOAD_ERROR:
      _uploadedImageUrl = null;
      FileUploadStore.emitChange(action.error);
      break;
    case ActionType.FILE_UPLOAD_ERROR:
      FileUploadStore.emitChange(action.error);
      break;
    case ActionType.FILE_UPLOAD_PROGRESS:
      _uploadProgress[action.uploadKey] = action.progress;
      FileUploadStore.emitChange();
      break;
    default:
      break;
  }
});

module.exports = FileUploadStore;

